import ptBR from "./pt-br.json";

export const labels = ptBR;
